/**
 * imgproxy signing config
 *
 * Here we apply some form of security trough obscurity.
 * Basically the imgproxy keys would be exposed in the source trough developer
 * tools, and that is pretty bad you would say. However, the alternative is
 * that the server would sign urls, and that leaves the security implementaiton
 * to use. Since imgProxy should be available to all users, I see no correct
 * way to properly secure the imgproxy calls in any way, so exposing the keys
 * here for the person that really wants to dig deep is a fine trade-off for me.
 *
 * @author Boy van der Laak
 */

export const IMGPROXY_URL = "https://transform.intractive.app";

const keyParts = [
  "4F",
  "73",
  "52",
  "6A",
  "6F",
  "54",
  "74",
  "33",
  "4B",
  "44",
  "59",
  "36",
  "43",
  "48",
  "4A",
  "54",
];
export const IMGPROXY_KEY = keyParts.join("");

const saltParts = [
  "75",
  "64",
  "34",
  "34",
  "53",
  "77",
  "46",
  "6A",
  "32",
  "59",
  "5A",
  "67",
  "4E",
  "63",
  "4C",
  "75",
];
export const IMGPROXY_SALT = saltParts.join("");
